import React from 'react';
import TopBar from '../components/layout/TopBar';
import SectionCard from '../components/widgets/SectionCard';
import { useApp } from '../context/AppContext';
import { Sparkles } from 'lucide-react';

export default function Configuracoes() {
  const { companies } = useApp();

  return (
    <div className="fade-in">
      <TopBar title="Configurações" subtitle="Preferências do sistema e operações administrativas" />
      <div className="px-8 py-7 space-y-5 max-w-4xl">
        <SectionCard title="Sobre o Sistema">
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <div className="overline text-zinc-500">Grupo</div>
              <div className="text-zinc-100 mt-1">CEAP BRASIL</div>
            </div>
            <div>
              <div className="overline text-zinc-500">Versão</div>
              <div className="text-zinc-100 mt-1 font-mono">1.2.0</div>
            </div>
            <div>
              <div className="overline text-zinc-500">Empresas Cadastradas</div>
              <div className="text-zinc-100 mt-1 font-mono">{companies.length}</div>
            </div>
            <div>
              <div className="overline text-zinc-500">Moeda Base</div>
              <div className="text-zinc-100 mt-1 font-mono">BRL (R$)</div>
            </div>
          </div>
        </SectionCard>

        <SectionCard title="Estrutura Implementada">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-xs">
            {[
              'Empresas e Participação Societária',
              'Fontes de Receita por empresa',
              'Centros de Custo',
              'Categorias por Tipo',
              'Lançamentos (Receitas/Custos/Despesas)',
              'Investimentos e Impostos',
              'DRE Gerencial',
              'Consolidação Automática com Participação',
              'Dashboard Executivo com KPIs',
              'Evolução Financeira Histórica',
              'Top Despesas e Centros de Custo',
              'Fluxo de Caixa Diário',
              'Fluxo de Caixa Provisionado (regra dia 10)',
              'Projeção 6 meses',
              'Contas a Pagar',
              'Contas a Receber',
              'Cobrança de Recebíveis (CRM com aging)',
              'Histórico de Cobrança por canal',
              'Contratos Recorrentes (MRR/ARR)',
              'Geração automática de parcelas',
              'Cursos & Eventos (lucro por curso)',
              'Ticket Médio e Custo por Aluno',
              'Meta vs Realizado',
              'Fechamento Mensal com Travamento',
              'Importação de Planilha Excel (2 templates)',
              'Ranking por Fonte de Receita',
              'Comparativo entre Empresas',
            ].map((feat, i) => (
              <div key={i} className="flex items-start gap-2 text-zinc-300">
                <Sparkles size={12} className="text-[#D4AF37] mt-0.5 shrink-0" />
                <span>{feat}</span>
              </div>
            ))}
          </div>
        </SectionCard>
      </div>
    </div>
  );
}
